import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';

export type GetPatientSummaryEDSParams = PatientCommandParams;

export const GetPatientSummaryEDS = (
	params: GetPatientSummaryEDSParams,
): Command => {
	return {
		operation: 'DajPacientskySumarEDS_v2',
		params,
	};
};
